import createIcon from '../../createIcon';

/**
 * @component @name ReportProblem
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAyMS41SDIzTDEyIDIuNUwxIDIxLjVaTTEzIDE4LjVIMTFWMTYuNUgxM1YxOC41Wk0xMyAxNC41SDExVjEwLjVIMTNWMTQuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReportProblem = createIcon('ReportProblem', [
  [
    'path',
    {
      d: 'M1 21.5H23L12 2.5L1 21.5ZM13 18.5H11V16.5H13V18.5ZM13 14.5H11V10.5H13V14.5Z',
      key: 'f696mu',
    },
  ],
]);

export default ReportProblem;
